export default __webpack_public_path__ + "static/media/bg-myimg4.bcb1e223.jpg";